import { theme } from '@chakra-ui/react';

import tailwindColors from './tailwindColors';

export const colors = {
  ...theme.colors,
  ...tailwindColors,
  brand: {
    50: '#8e9ade',
    100: '#6777d3',
    200: '#5365cd',
    300: '#3f53c7',
    400: '#3649b7',
    500: '#2A3990',
    600: '#1e2969',
    700: '#192255',
    800: '#131a41',
    900: '#070a1a',
  },
  gray: tailwindColors.blueGray,
  success: theme.colors.green,
  error: theme.colors.red,
  warning: theme.colors.yellow,
};
